import { Route, useLoaderData } from 'react-router';
import SentryRoutes from '../../../_mesomb/helpers/SentryRoutes.ts';
import { FundModel } from '../../../types';
import FundContributions from './components/FundContributions.tsx';
import FundDonate from './components/FundDonate.tsx';
import FundMessages from './components/FundMessages.tsx';
import FundOutlet from './components/FundOutlet.tsx';
import FundOverview from './components/FundOverview.tsx';

function FundContributePage() {
  const { fund } = useLoaderData<{ fund: FundModel }>();
  return (
    <SentryRoutes>
      <Route element={<FundOutlet fund={fund} />}>
        <Route path='' element={<FundOverview fund={fund} />} />
        <Route path='contribute' element={<FundDonate fund={fund} />} />
        <Route
          path='contributions'
          element={<FundContributions fund={fund} />}
        />
        <Route path='messages' element={<FundMessages fund={fund} />} />
      </Route>
    </SentryRoutes>
  );
}

export default FundContributePage;
